// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2K1ti","modalForm":"UpgradeEpcsModal_modalForm__3Kjqq","modalFooter":"UpgradeEpcsModal_modalFooter__2f4AD"};